import { Module } from "wrapper6";

var $ = jQuery;

export default class ProductPage extends Module {

    ready(app) {

        if(typeof defaultVariation !== 'undefined') {
            this.setVariationImages(null, defaultVariation)
        }

        let aElem = $('.woocommerce-product-gallery__image').children('a')[0];
        $(aElem).on('click', function(e){
            e.preventDefault();
        })

        $( ".single_variation_wrap" ).on( "show_variation", (event, variation) => this.setVariationImages(event, variation.variation_id) );

        this.setPreOrderButton();

    }

    setVariationImages ( event, variation_id ) {

        $('.woocommerce-product-gallery').addClass('loading');

        $(document).on('click', '.img-container', function(e){
            let url = $(e.target).data('img');
            $('.wp-post-image').attr('src', url);
            $('.wp-post-image').attr('srcset', '');

            $('.img-container.active').removeClass('active');
            $(e.target).addClass('active');

        });

        if($('.wp-post-image').attr('srcset') === 'false'){
            $('.wp-post-image').attr('srcset', '');
        }

        $.ajax(main_theme_objects.ajax_url,
            {
                data: {
                    'action': 'product_find_gallery',
                    'variation': variation_id,
                },
                success: function(response) {
                    if(response) {
                        let element = $('.woocommerce-product-gallery__wrapper')[0];
                        let defaultImg = $('.wp-post-image').attr('src');
                        let gallery = response.Gallery;
                        let datastring = '<div class="img-container active" data-img="' + defaultImg + '"></div>';
                        let i = 0;
                        for (let img in gallery) {
                            img = gallery[img];
                            datastring = datastring + '<div class="img-container" data-img="' + img.url + '"></div>';
                            i++;
                        }
                        $('.img-select-area').remove();
                        if(i !== 0){
                            datastring = '<div class="img-select-area">' + datastring + '</div>';
                            $(element).prepend(datastring);
                        }

                        $('#size-html').html(response.sizes);
                    }
                    $('.woocommerce-product-gallery').removeClass('loading');
                }
            });
    }

    setPreOrderButton() {
        if($('.single-product .product').hasClass('preorder')){            
            $('.single_add_to_cart_button').html('Forudbestil');
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_product-page.js